import React from 'react';

import StatusSummaryButton from '../../../status/statusSummaryButton.jsx';
import partnerPropTypes from '../../../partnerPropTypes.js';
import { data as paymentDataPropTypes } from '../../../paymentPropTypes.js';
import { viewStatus as viewStatusPropType } from '../../../safeTradePropTypes.js';
import { formatDate } from '../../../getDeadline.js';
import viewStatuses from '../../../viewStatus.js';

function createStatusSummary(sellerName, viewStatus, deadline) {
    const formattedDeadline = formatDate(deadline);
    const isDelayed = viewStatus === viewStatuses.PAYMENT_DELAYED;

    const intro = isDelayed
        ? `Vi har sendt en purring til ${sellerName}.`
        : `${sellerName} har fått beskjed om å sende varen.`;

    return (
        <div>
            <p className="man">
                {intro} Pengene utbetales automatisk til {sellerName}{' '}
                <strong>{formattedDeadline}</strong>. Du må selv stanse
                betalingen om du ikke får varen.
            </p>
        </div>
    );
}

const PaidSummary = ({ payment, partner, viewStatus }) => (
    <StatusSummaryButton
        href="/godkjenn-eller-avsla-vare"
        statusSummary={createStatusSummary(
            partner.name,
            viewStatus,
            payment.automaticApprove
        )}
        actionRequiredType="POSITIVE"
    >
        Har du fått varen eller venter du fortsatt?
    </StatusSummaryButton>
);

PaidSummary.propTypes = {
    payment: paymentDataPropTypes.isRequired,
    partner: partnerPropTypes.isRequired,
    viewStatus: viewStatusPropType.isRequired,
};

export default PaidSummary;



// WEBPACK FOOTER //
// ./safeTrade/buyer/payment/summaries/paidSummary.jsx